import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const backgroundImages = [
    '/hero_1.jpg',
    '/hero_2.jpg', 
    '/hero_3.jpg',
    '/hero_4.jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Image Carousel */}
      <div className="absolute inset-0">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          />
        ))}
        {/* Purple translucent overlay */}
        <div className="absolute inset-0 bg-purple-900 bg-opacity-60" />
        {/* Additional dark overlay for text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-30" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4">
        <div className="flex flex-col items-center text-center">
          {/* Text content */}
          <div className="w-full max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
              I make working out <span className="text-primary-300">fun and effective</span>
            </h1>

            <p className="text-xl text-gray-100 mb-8 leading-relaxed">
              Don't waste your time. Coach HT will get you to your health and fitness goals twice as fast using the PHYT method. A method focused on proper form and alignment.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
              <a 
                href="#packages" 
                className="w-full sm:w-auto bg-primary-500 text-white px-8 py-4 rounded-xl text-xl font-semibold hover:bg-primary-600 transition flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                onClick={(e) => {
                  e.preventDefault();
                  const packagesSection = document.getElementById('packages');
                  if (packagesSection) {
                    packagesSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Secure Your Spot
                <ArrowRight size={20} />
              </a>
            </div>
            
            <div className="mt-12 sm:mt-16">
              <div className="overflow-x-auto scrollbar-hide pb-4">
                <div className="flex sm:grid sm:grid-cols-3 gap-4 sm:gap-6 px-4 sm:px-0 max-w-5xl mx-auto">
                  <div className="text-center p-4 sm:p-6 lg:p-8 bg-white/90 backdrop-blur-sm rounded-2xl border border-white/20 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
                    <div className="text-4xl sm:text-5xl mb-2">🎯</div>
                    <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-primary-500 mb-2 sm:mb-3 lg:mb-4">8+</div>
                    <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight">Years Experience</div>
                  </div>
                  <div className="text-center p-4 sm:p-6 lg:p-8 bg-white/90 backdrop-blur-sm rounded-2xl border border-white/20 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
                    <div className="text-4xl sm:text-5xl mb-2">💪</div>
                    <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-primary-500 mb-2 sm:mb-3 lg:mb-4">500+</div>
                    <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight">Clients Trained</div>
                  </div>
                  <div className="text-center p-4 sm:p-6 lg:p-8 bg-white/90 backdrop-blur-sm rounded-2xl border border-white/20 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
                    <div className="text-4xl sm:text-5xl mb-2">🏆</div>
                    <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-primary-500 mb-2 sm:mb-3 lg:mb-4">95%</div>
                    <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight px-2">Success Rate</div>
                  </div>
                </div>
              </div>
            </div>

            <style jsx>{`
              .scrollbar-hide {
                -ms-overflow-style: none;
                scrollbar-width: none;
              }
              .scrollbar-hide::-webkit-scrollbar {
                display: none;
              }
            `}</style>
          </div>
        </div>
      </div>

      {/* Image indicators */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20">
        <div className="flex space-x-2">
          {backgroundImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentImageIndex 
                  ? 'bg-white scale-125' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;